export const infoMenu = [
    {
        image: 'bg-almuerzo',
        name: 'ALMUERZOS EJECUTIVOS',
        description: 'Ofrecemos almuerzos ejecutivos, manteniendo nuestra distintiva combinación de sabores auténticos.'
    },
    {
        titleButton:'VER MENÚ',
        pathMenu: 'https://drive.google.com/drive/folders/1z53XbrxWQKNYW5ofkZI9q93aamANB5R4',
        image: 'bg-hamburguesa',
        name: 'NUESTRO MENÚ',
        description: 'Sumérgete en una experiencia culinaria inigualable en nuestro restaurante, donde los platos cobran vida a través de una fusión única de sabores e influencias. Inspirados por las ricas tradiciones culinarias de culturas como la mexicana y mediterránea, nuestro menú se convierte en una obra maestra de exquisitez y creatividad.'
    },
];